export default "__VITE_ASSET__BOo1x8f3__"